import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  chatFormSendButton: {
    id: 'chat.form.button.send',
    description: 'Label for chat form send-button',
    defaultMessage: 'Send',
  }
});
